import React, {useRef, useState} from "react";
import "./Oneclick.css";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";

import {sleep} from "../../../../lib/utils";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import ReactJsonView from "@microlink/react-json-view";
import {Accordion} from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import Row from "react-bootstrap/Row";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";

const DEVICE_TYPES = ["CF", "MS", "FP", "LT", "GX"]


function Oneclick({bond, signalData, signalFreq}) {

    const fwVersionRef = useRef();
    const deviceTypeRef = useRef();

    const [detectedRemotes, setDetectedRemotes] = useState();

    async function detect() {
        const reqId = crypto.randomUUID().replace(/-/g, '').slice(0, 10);
        window.postMessage({
            __palantirId: reqId,
            action: "oneclickRequest",
            raw: signalData,
            freq: signalFreq,
            fwVersion: fwVersionRef.current.value,
            deviceType: deviceTypeRef.current.value
        }, "*");

        const startTimestamp = new Date().getTime();
        while (!window.oneclickResponses[reqId] && startTimestamp + 3000 > new Date().getTime()) {
            await sleep(50);
        }
        const oneclickResponse = window.oneclickResponses[reqId];
        delete window.oneclickResponses[reqId]

        setDetectedRemotes(oneclickResponse.response);
    }


    return (<Row className={"mt-4"}>
        <Col lg={4} xs={12}>
            <h4><FontAwesomeIcon icon={faListCheck}/> Oneclick</h4>
        </Col>
        <Col lg={8} xs={12}>
            <InputGroup className={"rxResult"}>
                <InputGroup.Text>Fw Version</InputGroup.Text>
                <Form.Control
                    type="text"
                    defaultValue={`v10`}
                    ref={fwVersionRef}
                />
                <InputGroup.Text>Device Type</InputGroup.Text>
                <Form.Control
                    type="text"
                    list="deviceTypes"
                    defaultValue={`CF`}
                    ref={deviceTypeRef}
                />
                <datalist id="deviceTypes">
                    {DEVICE_TYPES.map((t) => (<option key={t}>{t}</option>))}
                </datalist>
                <Button variant="primary" onClick={detect}>Detect</Button>
            </InputGroup>
        </Col>

        {detectedRemotes && <Col className={"mt-3"}>
            <h5>
                Detected Remotes
                {Object.keys(detectedRemotes).sort().map((value) => <Badge bg={"success"}
                                                                           className={"ms-2"}>{value}</Badge>)}
                {Object.keys(detectedRemotes).length === 0 && <Badge bg={"danger"}>No detection</Badge>}
            </h5>
            <Accordion defaultActiveKey={""}>
                {Object.entries(detectedRemotes).sort().map(([key, remote]) => <Accordion.Item eventKey={key}>
                    <Accordion.Header>
                        <Row className={"w-100"}>
                            <Col xs={2} className={"align-content-end"}><h3><Badge bg={"success"}
                                                                                   className={"me-2"}>{key}</Badge>
                            </h3></Col>
                            <Col xs={8} className={"align-content-center"}>{remote.info.title}</Col>
                            <Col xs={2} className={"align-content-end"}>
                                <h4 className={"text-end me-2"}>
                                    <Badge pill bg={"secondary"} className={""}>{remote.state.addr}</Badge>
                                </h4></Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body className={"oneclickResponseRemote"}>
                        <ReactJsonView
                            src={remote ? remote : {}}
                            theme={"tomorrow"}
                            name={false}
                            sortKeys={true}
                            displayObjectSize={false}
                            displayDataTypes={false}
                        />
                    </Accordion.Body>
                </Accordion.Item>)}
            </Accordion>

        </Col>}
    </Row>);
}

export default Oneclick;
